import React, {useEffect,useContext} from 'react'; 
import { Route, Redirect } from 'react-router-dom';
import MapView from '../components/MapView/MapView';
import MapViewv2 from '../components_v2/MapView/MapView';
import { isLogin } from '../functions/Auth';
import MapContext from '../context/MapContext'
import Header from '../components_v2/Headers/Header';
export const UserRoute = ({ component: Component,  ...rest }) => {
    const [clicked, setClicked] = React.useState(true);
    const {versionNum}=useContext(MapContext)
    useEffect(
        () => {            
            if(rest.location.state) {
                setClicked(rest.location.state);
            //     setLogin(props.location.state.newLogin);
            }           
        },[rest])
    return (
        <>
        <Header />
        {
            !isLogin() && versionNum == 1 ?
            <MapView clicked = {clicked}/>
            : 
            (!isLogin() && versionNum == 2) &&      
            <MapViewv2 clicked = {clicked}/>
        }   
            <Route {...rest} render={(props) => {       
                const urlParams = new URLSearchParams(window.location.search),
                stationData = urlParams.get('station');         
                if (!isLogin()) {
                    if(props.location.pathname !== "/")
                        return <Component {...props} />
                } else {
                    if(props.location.pathname == "/set_new_password" || props.location.pathname == "/reset_password" || props.location.pathname == "/password_updated") {
                        return <Component {...props} />
                    } else {                             
                        var params =  ((stationData != null)?'?station='+stationData : '');                        
                        return <Redirect to={{
                            pathname:'/UsersDashboard',
                            search:params
                            // state:props.location               
                        }} />
                    }              
                }                
            }
            }></Route></>
    )
}